import React from 'react'
import { useMarketSelectorLogic } from './MarketSelector.logic.js'
import { MarketSelectorView } from './MarketSelector.view.jsx'

export function MarketSelector() {
  const logic = useMarketSelectorLogic()
  return <MarketSelectorView {...logic} />
}
